import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { defaultRouteFor, useAuth } from '../auth'

export function ChangePasswordPage() {
  const auth = useAuth()
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  if (auth.loading) return <div className="auth-loading">正在确认登录状态…</div>
  if (!auth.user) return <Navigate to="/login" replace />

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (newPassword !== confirm) {
      setError('两次输入的新密码不一致')
      return
    }
    setBusy(true)
    setError('')
    try {
      await auth.changePassword(currentPassword, newPassword)
      navigate('/login', { replace: true, state: { message: '密码已更新，请重新登录。' } })
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : String(reason))
    } finally {
      setBusy(false)
    }
  }

  return <main className="auth-page"><section className="auth-card auth-password-card">
    <div className="auth-brand"><span>熊</span><div><strong>{auth.user.username}</strong><small>{auth.user.phone}</small></div></div>
    <header><h1>{auth.user.mustChangePassword ? '请修改初始密码' : '修改密码'}</h1><p>新密码至少10位，同时包含字母和数字或符号。</p></header>
    <form onSubmit={submit}>
      <label><span>当前密码</span><div><input type="password" autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required /></div></label>
      <label><span>新密码</span><div><input type="password" autoComplete="new-password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required /></div></label>
      <label><span>再次输入新密码</span><div><input type="password" autoComplete="new-password" value={confirm} onChange={(event) => setConfirm(event.target.value)} required /></div></label>
      {error ? <p className="auth-error" role="alert">{error}</p> : null}
      <button type="submit" disabled={busy}>{busy ? '正在保存…' : '保存新密码'}</button>
      {!auth.user.mustChangePassword ? <button className="auth-secondary-button" type="button" onClick={() => navigate(defaultRouteFor(auth.user!))}>取消</button> : null}
    </form>
  </section></main>
}
